<template>
    <div>
        <el-dialog
                width="400px"
                :visible.sync="visible"
                :show-close="false"
                :close-on-click-modal="false"
        >
            <div slot="title">
                <z-title :title="(type==0?'新增':'编辑')+'预定类型'"></z-title>
            </div>
            <el-form :model="info" :rules="rules" ref="ruleForm" class="rulefrom">
                <el-form-item label="名 称" prop="orderTypeName" label-width="80px">
                    <el-input maxlength="16" v-model="info.orderTypeName" placeholder="请输入预定类型"></el-input>
                </el-form-item>
                <el-form-item label="状 态" prop="orderTypeState" label-width="80px">
                    <el-radio-group v-model="info.orderTypeState">
                        <el-radio label="0">启用</el-radio>
                        <el-radio label="1">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否喜宴" prop="isWedding" label-width="80px">
                    <el-radio-group v-model="info.isWedding">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排 序" prop="orderIndex" label-width="80px">
                    <el-input maxlength="16" style="text-align: left;!important;" v-model="info.orderIndex" placeholder="请输入排序" v-number></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')"  :loading="loading">保 存</el-button>
                    <el-button @click="resetForm">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "edit-order-type",
        props:{
            visible:Boolean,
            type:Number|String,
            id:String
        },
        data(){
            return{
                loading:false,
                info:{
                    orderIndex:'',
                    orderTypeState:'0',
                    isWedding:'0',
                    orderTypeName:''
                },
                rules: {
                    orderTypeName: [{required: true, message: '名称不能为空', trigger: 'blur'}]
                },
            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    if(this.type==1){
                        this.loading=true;
                        this.getData();
                    }
                }
            }
        },
        methods:{
            getData(){
                this.$axios.get('orderType/orderTypeById/'+this.id).then(res=>{
                    console.log('预定类型',res.data)
                    this.loading=false;
                    var info=res.data;
                    this.info=info;
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            addOrderType(){
                var info=this.info;
                this.$axios.post('/orderType/orderTypeAdd',{
                    storeId: this.$root.getStorage('storeId'),
                    orderIndex: info.orderIndex,
                    isWedding:info.isWedding,
                    orderTypeName: info.orderTypeName,
                    orderTypeState:info.orderTypeState
                }).then(res=>{
                    this.$message.success('新增预定类型成功！');
                    this.resetForm();
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            editOrderType(){
                var info=this.info;
                this.$axios.post('/orderType/orderTypeUpdate',{
                    id:this.id,
                    storeId: this.$root.getStorage('storeId'),
                    orderIndex: info.orderIndex,
                    isWedding:info.isWedding,
                    orderTypeState:info.orderTypeState,
                    orderTypeName: info.orderTypeName
                }).then(res=>{
                    this.$message.success('编辑预定类型成功！');
                    this.resetForm();
                }).catch(err=>{
                    this.loading=false;
                    this.$message.error(err.msg);
                })
            },
            submitForm(formName) {
                this.loading=true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.type==0){
                            this.addOrderType();
                        }else{
                            this.editOrderType();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        this.loading=false;
                        return false;
                    }
                });
            },

            resetForm(){
                this.loading=false;
                this.$store.state.refresh=true;
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped>

</style>